import styled from '@emotion/styled';
import { Stack } from '@mui/material';
import { colors } from 'theme/colors';

export const StyledDetailsWrapper = styled(Stack)`
  padding: 20px;
  border-radius: 4px;
  gap: 24px;
  margin-top: 16px;
  border: 1px solid ${colors.gray200};
  background-color: ${colors.gray100};
`;
